<template lang="html">
  <div class="alert-content">
    <div
      class="page-alert"
      :class="parse(item).type"
      v-for="(item, index) in items"
      @click.self="highlightField('type')"
      :key="`alert-${index}`">

      <Sprite :name="`alert-${parse(item).type}`"/>
      <p @click="highlightField('content')">{{parse(item).content}}</p>
    </div>
  </div>
</template>

<script>
import parseComponent from '@/mixins/parseComponent'
import Sprite from '@/components/Sprite'

export default {
  name: 'Alert',

  mixins: [parseComponent],

  components: {
    Sprite
  },

  props: {
    currentListItem: {
      type: Object,
      description: 'This is the type of list'
    },

    items: {
      type: Array,
      description: 'The current list item'
    }
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/helpers/mixins'

.alert-content
  .page-alert
    border: 1px solid
    padding: $gap-small
    text-align: center
    font-weight: bold
    font-size: 16px
    margin-bottom: $gap-small
    display: flex
    align-items: center
    justify-content: center
    transition: all .2s ease-in-out

    p
      margin: 0

    .sprite
      width: 25px
      height: 25px
      margin-right: $gap-small

    &.general
      background: #ffffff
      border-color: #404040
      color: #404040

      .sprite
        fill: #404040

    &.error
      background: #efdfde
      color: #9a4845
      border-color: #9a4845

      .sprite
        fill: #9a4845

    &.success
      background: #e2efda
      color: #6da04d
      border-color: #6da04d

      .sprite
        fill: #6da04d

    &.notice
      background: #fbf8e5
      color: #a78d25
      border-color: #a78d25

      .sprite
        fill: #a78d25
</style>
